const routes = [
    {
        path: "/semesters",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "semester_index"
        }
    }
];

export default routes;
